import {
  NUM_COLUMNS_WITH_IMAGE_LAYOUT,
  NUM_COLUMNS_WITHOUT_IMAGE_LAYOUT,
} from '../presentation/utils/constants';

export function getNumberOfColumns({
  hasImages,
  snapDirection,
  imageLayoutPosition,
  gridColumns,
}: {
  hasImages: boolean;
  snapDirection: 'x' | 'y';
  imageLayoutPosition: { start: number; end: number };
  gridColumns: number;
}): 2 | 3 {
  const hasSideImageLayout = hasImages && snapDirection === 'x';
  const { start, end } = imageLayoutPosition;
  const hasFullWidthImageLayout =
    (start === 0 && end === 0) || (start === 1 && end === gridColumns);
  return hasSideImageLayout && !hasFullWidthImageLayout
    ? NUM_COLUMNS_WITH_IMAGE_LAYOUT
    : NUM_COLUMNS_WITHOUT_IMAGE_LAYOUT;
}
